import { List, Map } from "immutable";

import Course from "seneca-common/features/course/state/models/state/courses/course/Course";
import Reference, {
  ReferenceType
} from "seneca-common/features/course/state/models/state/courses/course/references/reference/Reference";
import { References } from "seneca-common/features/course/state/models/state/courses/course/references/References";
import Tag, {
  TagType
} from "seneca-common/features/course/state/models/state/courses/course/tags/tag/Tag";

export function transformServerCourseDetails(
  courseDetails: Record<string, any>
): Course {
  const { authors, references, sectionIds, tags, relatedCourseIds, regions } =
    courseDetails;

  const course = {
    ...courseDetails,
    regions: List(regions),
    authors: List(authors) as List<string>,
    tags: tagsToImmutableTags(tags),
    sectionIds: List(sectionIds),
    relatedCourseIds: List(relatedCourseIds),
    references: transformReferences(references)
  };

  // @ts-ignore
  return new Course(course);
}

export function transformReferences(references: ReferenceType[]): References {
  // @ts-ignore
  return List(references).map(reference => new Reference(reference));
}

export function flattenCourse(course: Record<string, any>): Course {
  const {
    sections,
    sectionIds,
    tags,
    authors,
    references,
    regions,
    relatedCourseIds,
    ...rest
  } = course;

  return new Course({
    ...rest,
    available: true,
    authors: List(authors),
    // @ts-ignore
    references: transformReferences(references),
    sectionIds: sections
      ? List(sections).map((section: any) => section.id)
      : List(sectionIds),
    tags: tags ? tagsToImmutableTags(tags) : tags,
    regions: List(regions),
    relatedCourseIds: List(relatedCourseIds)
  });
}

type TagsFromServerType = Record<
  string,
  Array<{
    id: string;
  }>
>;

export function tagsToImmutableTags(tags: TagsFromServerType) {
  return Object.keys(tags).reduce((immutableTags, catId) => {
    const tagsPerCategory = List(tags[catId]).map(
      // @ts-ignore
      (tag): TagType => new Tag(tag)
    );
    return immutableTags.set(catId, tagsPerCategory);
  }, Map());
}
